/* Triumph DATA PLATE | tl-footer.js
   Site footer behaviour (port of REF site-footer.init.js):
   - marks the footer .is-js, which lets the CSS collapse the link columns into accordions under 760px
     (without JS every link stays visible);
   - the column toggles (button.tl-ft__tog) open/close their list and keep aria-expanded in sync;
   - [data-year] shows the visitor's current year (the Liquid prints the render year; pages can be cached).
   The Wix aria-current marking is done in Liquid now (full page loads), and the wordmark image fallback
   lives in tl-global.js. Re-initialises on the theme editor's shopify:section:load. */
(function () {
  'use strict';

  function toggle(e) {
    var btn = e.currentTarget;
    var col = btn.closest('.tl-ft__col');
    if (!col) return;
    var open = !col.classList.contains('is-open');
    col.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function setup(ft) {
    if (!ft || ft.dataset.tlInit) return;
    ft.dataset.tlInit = '1';
    ft.classList.add('is-js');

    var year = String(new Date().getFullYear());
    var years = ft.querySelectorAll('[data-year]');
    for (var i = 0; i < years.length; i++) years[i].textContent = year;

    var togs = ft.querySelectorAll('.tl-ft__tog');
    for (var j = 0; j < togs.length; j++) togs[j].addEventListener('click', toggle);
  }

  function initAll(scope) {
    var root = scope || document;
    if (root.matches && root.matches('[data-tl-footer]')) {
      setup(root);
      return;
    }
    var list = root.querySelectorAll('[data-tl-footer]');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
